/** Element name per drawing mode, shown as "<Element> einzeichnen beenden". */
export const DRAW_MODE_ELEMENT_LABELS: Partial<
  Record<NonNullable<StructuralPlanningModes>, string>
> = {
  'draw-roofs': 'Dachflächen',
  'draw-slabs': 'Deckenflächen',
  'draw-walls': 'Wände',
  'draw-openings': 'Öffnungen',
  'draw-vertical-roofs': 'Dachpositionen',
  'draw-vertical-slabs': 'Deckenpositionen',
  'draw-purlins': 'Pfetten',
  'draw-columns': 'Stützen',
  'draw-beams': 'Unterzüge',
  'wall-rip': 'Rippe',
  'wall-lintel': 'Fensterstürze',
}
